import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { path: '/services/creation-sites-web', label: 'Création de Sites Web' },
    { path: '/services/intelligence-artificielle', label: 'Intelligence Artificielle' },
    { path: '/services/referencement-seo', label: 'Référencement SEO' },
    { path: '/services/publicite-sea', label: 'Publicité SEA' },
    { path: '/services/gestion-reseaux-sociaux', label: 'Réseaux Sociaux' }
  ];

  const company = [
    { path: '/#about', label: 'À Propos' },
    { path: '/equipe', label: 'Notre Équipe' },
    { path: '/#case-studies', label: 'Nos Réalisations' },
    { path: '/linkedin', label: 'LinkedIn' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.svg" 
                alt="EnovationWeb" 
                className="w-12 h-12"
              />
              <span className="text-white font-semibold text-lg">
                EnovationWeb
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Votre partenaire digital tunisien pour transformer vos ambitions en succès. 
              Expertise, innovation et résultats mesurables.
            </p>
            <div className="flex space-x-4 pt-2">
              <a 
                href="https://www.linkedin.com/company/enovationweb" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Nos Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-slate-400 hover:text-emerald-400 text-sm transition-colors duration-200 inline-block"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Entreprise</h3>
            <ul className="space-y-3">
              {company.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-slate-400 hover:text-emerald-400 text-sm transition-colors duration-200 inline-block"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <Mail className="w-5 h-5 mt-0.5 text-emerald-500 flex-shrink-0" />
                <a 
                  href="mailto:contact@enovationweb.com"
                  className="hover:text-emerald-400 transition-colors duration-200"
                >
                  contact@enovationweb.com
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <Phone className="w-5 h-5 mt-0.5 text-emerald-500 flex-shrink-0" />
                <a 
                  href="tel:+21622360360"
                  className="hover:text-emerald-400 transition-colors duration-200"
                >
                  +216 22 360 360
                </a>
              </li>
              <li className="flex items-start space-x-3 text-slate-400 text-sm">
                <MapPin className="w-5 h-5 mt-0.5 text-emerald-500 flex-shrink-0" />
                <span>
                  Rue du Lac Victoria<br />
                  Les Berges du Lac 1<br />
                  1053 Tunis, Tunisie
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-slate-400 text-sm">
              © {currentYear} EnovationWeb. Tous droits réservés.
            </p>
            <div className="flex items-center space-x-6">
              <Link 
                to="/mentions-legales" 
                className="text-slate-400 hover:text-emerald-400 text-sm transition-colors duration-200"
              >
                Mentions Légales
              </Link>
              <Link 
                to="/politique-confidentialite" 
                className="text-slate-400 hover:text-emerald-400 text-sm transition-colors duration-200"
              >
                Confidentialité
              </Link>
              <Link 
                to="/cgv" 
                className="text-slate-400 hover:text-emerald-400 text-sm transition-colors duration-200"
              >
                CGV
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
